import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDrawer3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H11.25V19H5.5V21H4V19H2V4ZM9.5 9H8V13H9.5V9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18.5 19H12.75V4H22V19H20V21H18.5V19ZM16 9V13H14.5V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer3;
